import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import CreateMeltingRequestForm from './CreateMeltingRequestForm'
function CreateMeltingRequest() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Melting - Melting-Request</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <CreateMeltingRequestForm />
            </div>
        </div>


    )
}

export default CreateMeltingRequest
